import axios from "axios";
import { getToken, isTokenValid } from "./auth";
import { lockState } from "./systemLock";

const endpoint = "/api/sysConfig/OnlineUsers/";
let pending = null;
let leaving = false;

// The list must wait for the current login to be registered before reading sessions.
export function reportOnlinePresence() {
	if (pending) return pending;
	if (leaving || lockState.locked || !isTokenValid()) return Promise.reject(new Error("当前会话未登录或已锁定，无法更新在线状态"));
	pending = axios.post(endpoint + "Heartbeat", {}, {
		headers: { Authorization: `Bearer ${getToken()}` }, timeout: 10000
	}).then(response => {
		const result = response.data;
		if (!result || result.code !== 1) throw new Error(result && result.msg || "在线心跳上报失败");
		return result;
	}).catch(error => {
		if (error.response && error.response.status === 404) throw new Error("在线用户接口不存在，请确认后端已更新");
		throw error;
	}).finally(() => { pending = null; });
	return pending;
}

export async function leaveOnlineSession() {
	const token = getToken();
	if (!token || leaving) return;
	leaving = true;
	try {
		// Finish any earlier heartbeat before removing this login session.
		if (pending) await pending.catch(() => {});
		await axios.post(endpoint + "Leave", {}, { headers: { Authorization: `Bearer ${token}` }, timeout: 5000 });
	} catch (_) { /* If offline, the server expires presence automatically. */ }
	finally { leaving = false; }
}

export function startOnlinePresence(router) {
	const beat = () => {
		const path = router.currentRoute.path;
		if (pending || leaving || document.hidden || lockState.locked || path === "/" || path === "/login" || !isTokenValid()) return;
		reportOnlinePresence().catch(() => {});
	};
	router.afterEach(beat);
	document.addEventListener("visibilitychange", beat);
	window.addEventListener("online", beat);
	window.setInterval(beat, 20000);
	beat();
}
